export default "__VITE_ASSET__DKzE3i9n__"